<template>
  <div>
    <lk-table :columns='columns' :data='row.purchaseMedicineInfoVoList' class="mytable"/>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  mounted() {
    // console.log(this.row.purchaseMedicineInfoVoList);
  },
  data() {
    return {
      columns: [
        {
          title: '行号',
          width: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        { title: '商品名称', key: 'medicineInfoVoGoodsName', minWidth: 142 },
        { title: '规格', key: 'medicineInfoVoSpecifications', minWidth: 130 },
        { title: '产地', key: 'purchaseMedicineCountryOfOrigin', minWidth: 142 },
        { title: '生产企业', key: 'medicineInfoVoManufacturer', minWidth: 142 },
        { title: '批号', key: 'purchaseReceiptInfoGoodsBatchNum', minWidth: 82 },
        { title: '待装斗数量', key: 'purchaseReceiptInfoAcceptNum', minWidth: 100 },
        { title: '计量单位', key: 'purchaseMedicineDrugMinimumPackagingUnit', minWidth: 82 },
        { title: '单价', key: 'purchaseReceiptInfoPriceBeforeTax', minWidth: 82 },
        { title: '总金额', key: 'purchaseReceiptInfoTotalPriceBeforeTax', minWidth: 90 },
      ],
    };
  },
};
</script>
